import { LANGUAGES } from "../lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const DocLanguageSelect = ({ value, onChange, testId, disabled }) => (
  <Select value={value || "en"} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger className="rounded-sm" data-testid={testId} data-no-translate><SelectValue /></SelectTrigger>
    <SelectContent data-no-translate>
      {LANGUAGES.map((l) => <SelectItem key={l.code} value={l.code} data-testid={`${testId}-${l.code}`}>{l.label}</SelectItem>)}
    </SelectContent>
  </Select>
);
